import {Component, Input} from '@angular/core';

@Component({
    selector: 'form-page-layout',
    templateUrl: './form-page-layout.component.html'
})
export class FormPageLayoutWidget {
    @Input() title: string;
    @Input() icon: string;
    @Input() errors: Array<string>;
    @Input() successes: Array<string>;
    @Input() goBackLink: string;
}
